import { render, staticRenderFns } from "./BookShiftCard.vue?vue&type=template&id=825c3364&scoped=true"
import script from "./BookShiftCard.vue?vue&type=script&lang=js"
export * from "./BookShiftCard.vue?vue&type=script&lang=js"
import style0 from "./BookShiftCard.vue?vue&type=style&index=0&id=825c3364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825c3364",
  null
  
)

export default component.exports